import { render, staticRenderFns } from "./SelectMiddleman.vue?vue&type=template&id=4c6c1090&"
import script from "./SelectMiddleman.vue?vue&type=script&lang=js&"
export * from "./SelectMiddleman.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports